import { Component } from "react"
import dispatchEvent from "../../helpers/dispatch-event"
import { root } from "../../services/Globals"

const noop = () => {}

export default class PostAudiotracks extends Component {
  constructor(props) {
    super(props)
    this.initialState = {
      mode: `idle`,
      payload: undefined,
    }
    this.state = this.initialState
  }

  render = () => {
    const {
      state: { mode, payload },
      create,
    } = this

    return this.props.children({
      mode,
      payload,
      create,
    })
  }

  create = options => {
    const {
      data,
      arrangementId,
      versionId,
      onSuccess = noop,
      onError = noop,
      onLoading = noop,
    } = options || this.props

    this.setState(
      previousState => ({
        ...previousState,
        mode: `loading`,
      }),
      onLoading
    )

    return root.wav
      .api({
        method: `post`,
        url: `/arrangements/${ arrangementId }/versions/${ versionId }/audiotracks`,
        data,
      })
      .then(response => {
        onSuccess(response.data)
        dispatchEvent(`update:${ arrangementId }:audiotracks`)
        dispatchEvent(`update:${ versionId }:audiotracks`)
        return response
      })
      .catch(error => {
        this.setState(
          previousState => ({
            ...previousState,
            mode: `error`,
            payload: error,
          }),
          () => onError(error)
        )
      })
  }
}
